/**
 * Price helpers aligned with treez-tlp `utils/treez.ts` (GraphQL Int = centavos).
 */
const calculatePrice = (value: string): number => {
    const parsedValue = parseFloat(value);

    if (Number.isNaN(parsedValue)) {
        return 0;
    }

    const roundedValue = parsedValue.toFixed(2);
    const cents = parseInt(roundedValue.replace(".", ""), 10);

    return cents;
};

const getSalePrice = (
    discountedPrice: string | null | undefined,
    price: number,
): number => (discountedPrice ? calculatePrice(discountedPrice) : price);

export { calculatePrice, getSalePrice };
